import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  option: {
    id: `app.containers.WorkflowEditor.components.Rules.Condition.components.PartnerOptionSelect.option`,
    defaultMessage: 'Option',
  },
});
